var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSmartCities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.55566,16.36133a5.0642,5.0642,0,0,0-2.13867.47217,9.63221,9.63221,0,0,0-18.17871-1.94141A5.99831,5.99831,0,0,0,29.333,14.5835a6.08325,6.08325,0,0,0,0,12.1665H51.55566a5.19434,5.19434,0,1,0,0-10.38867Zm0,8.88867H29.333a4.58326,4.58326,0,1,1,1.99023-8.707.7491.7491,0,0,0,1.03125-.41992,8.13128,8.13128,0,0,1,15.74512,2.001.74989.74989,0,0,0,1.20605.52344,3.65383,3.65383,0,0,1,2.25-.78613,3.69434,3.69434,0,1,1,0,7.38867Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75,40a.7502.7502,0,0,0-.75-.75H52a.7502.7502,0,0,0-.75.75V69.25h-4.5V48a.7502.7502,0,0,0-.75-.75H34a.7502.7502,0,0,0-.75.75V69.25h-4.5V44a.7502.7502,0,0,0-.75-.75H12a.7502.7502,0,0,0-.75.75V69.25H8v1.5H72v-1.5H68.75ZM27.25,69.25H12.75V44.75h14.5Zm18,0H34.75V48.75h10.5Zm22,0H52.75V40.75h14.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 44,
    width: 1.5,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 44,
    width: 1.5,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 44,
    width: 1.5,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 63.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 59.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 41.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 52,
    width: 1.5,
    height: 4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 41.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 60,
    width: 1.5,
    height: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.66455,
    cy: 36.66797,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.33423,
    cy: 33.33374,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 30,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 34.66504,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.20776,
    cy: 30,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 36,
    r: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.40747,
    cy: 34.03149,
    r: 1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.80518,
    cy: 32.05688,
    r: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39.33032,
    r: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 44,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmartCities);
export default __webpack_public_path__ + "static/media/icon_smart_cities.19fb53320298ac10ba9f42eb5cb39453.svg";
export { ForwardRef as ReactComponent };